import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_INTEGRATIONS } from "@/lib/service-content/faqs/integrations";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/shopify-integration-services";

export const Route = createFileRoute("/shopify-integration-services")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify Integration Services: ERP, OMS, PIM, WMS & 3PL · Shugert",
    description: "Shopify integration architecture with explicit data contracts, retries, reconciliation and operational ownership. Custom Build or Replatform from $5,000.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-integrations-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }, { name: "Shopify Integrations", path: PATH }]),
      faqJsonLd(FAQS_INTEGRATIONS.en),
      serviceJsonLd({
        name: "Shopify Integration Services",
        description: "Shopify integrations for ERP, OMS, PIM, WMS, 3PL and finance systems with data contracts, failure handling, monitoring and handoff.",
        path: PATH,
        serviceType: "Shopify Integrations",
        minPrice: 5000,
        unit: "PROJECT",
        deliverables: ["System inventory", "Data contract and field ownership", "Failure and recovery design", "Staged integration pipeline", "Monitoring, reconciliation and runbook"],
        locale: "en",
      }),
    ],
  }),
});
